var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleMeet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.324,
    height: 20.838,
    viewBox: "0 0 25.324 20.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.366,21.789l2.469,2.822,3.32,2.121.579-4.924-.579-4.816-3.383,1.864Z",
    transform: "translate(-12.04 -11.37)",
    fill: "#00832d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,29.823v4.2a1.736,1.736,0,0,0,1.736,1.736h4.2l.868-3.172-.868-2.761-2.88-.868Z",
    transform: "translate(-6 -14.918)",
    fill: "#0066da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.933,9,6,14.933l3.053.868,2.88-.868.854-2.725Z",
    transform: "translate(-6 -9)",
    fill: "#e94235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.933,17.434H6v8.972h5.933Z",
    transform: "translate(-6 -11.501)",
    fill: "#2684fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.405,12.488l-3.79,3.11v9.74l3.806,3.121a.869.869,0,0,0,1.4-.685V13.159A.869.869,0,0,0,32.405,12.488Zm-9.578,7.907V24.88H14.434v5.933H26.879a1.736,1.736,0,0,0,1.736-1.736V25.337Z",
    transform: "translate(-8.501 -9.975)",
    fill: "#00ac47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.879,9H14.434v5.933h8.393v4.486l5.788-4.8V10.736A1.736,1.736,0,0,0,26.879,9Z",
    transform: "translate(-8.501 -9)",
    fill: "#ffba00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMeet);
export default __webpack_public_path__ + "static/media/google-meet.fe06b88737babe91f12b453838647353.svg";
export { ForwardRef as ReactComponent };